import { Box, InputBase, Typography, styled } from "@mui/material";
import "../../theme/muiTypes.d.ts";

export const TextInputContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "error" && prop !== "multiline" && prop !== "readOnly",
})<{ error?: boolean; multiline?: boolean; readOnly?: boolean }>(
  ({ theme, error, multiline, readOnly }) => ({
    borderRadius: "8px",
    border: `1px solid ${
      error ? theme.palette.status?.error : theme.palette.border?.medium
    }`,
    backgroundColor: readOnly ? "#F1F5F9" : theme.palette.background?.secondary,
    display: "flex",
    height: multiline ? "400px" : "48px",
    padding: multiline ? "12px 16px" : "0 16px",
    alignItems: multiline ? "flex-start" : "center",
    gap: "10px",
    alignSelf: "stretch",
    cursor: readOnly ? "default" : "text",
    "&:hover": {
      borderColor: readOnly
        ? theme.palette.border?.medium
        : error
          ? theme.palette.status?.error
          : theme.palette.primary?.main,
    },
    "&:focus-within": {
      borderColor: readOnly
        ? theme.palette.border?.medium
        : error
          ? theme.palette.status?.error
          : theme.palette.primary?.main,
      outline: "none",
    },
  }),
);

export const TextInputField = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== "ref",
})(({ theme }) => ({
  width: "100%",
  height: "100%",
  "& .MuiInputBase-input": {
    height: "100%!important",
    padding: 0,
    fontSize: "16px",
    color: theme.palette.text?.primary,
    fontFamily: "Nunito, sans-serif",
    "&::placeholder": {
      color: theme.palette.text?.secondary,
      opacity: 1,
    },
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text?.secondary,
  fontFamily: "Nunito, sans-serif",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  marginBottom: "2px",
  paddingLeft: "8px",
  display: "block",
}));
